export interface LookerIframeOptions {
	lookerId: string;
}

export interface NewDashletOptions {
	templateDashboardId?: string;
}

export interface DashboardFilterOptions {
	dashboardId: string;
	filters: string;
}

export enum LookerDashletType {
	Billing = 'Billing',
}
